import React from 'react';

const Paginator = ({
  pagination,
  page,
  rows,
  totalRecords,
  currentPage,
  lastPage,
  perPage,
  onPageChange,
}) => {
  const activePage =
    (pagination && pagination.current_page) ||
    page ||
    currentPage ||
    1;

  const perPageValue =
    (pagination && pagination.per_page) ||
    rows ||
    perPage ||
    10;

  const total =
    (pagination && pagination.total) ||
    totalRecords ||
    0;

  const totalPagesRaw =
    (pagination && pagination.last_page) ||
    lastPage ||
    (total > 0 && perPageValue > 0
      ? Math.ceil(total / perPageValue)
      : 1);

  const totalPages = totalPagesRaw < 1 ? 1 : totalPagesRaw;

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (newPage) => {
    if (
      !onPageChange ||
      newPage < 1 ||
      newPage > totalPages ||
      newPage === activePage
    ) {
      return;
    }
    onPageChange(newPage);
  };

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
      <div className="mb-3 mb-md-0">
        <span className="text-muted">
          Total Records: {total}
        </span>
      </div>
      <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
          <li className={`page-item ${activePage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(activePage - 1)}
              disabled={activePage === 1}
            >
              Previous
            </button>
          </li>
          {pageNumbers.map((pageNumber) => (
            <li
              key={pageNumber}
              className={`page-item ${activePage === pageNumber ? 'active' : ''}`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </button>
            </li>
          ))}
          <li className={`page-item ${activePage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(activePage + 1)}
              disabled={activePage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Paginator;
